import { createAction } from '@reduxjs/toolkit';

export const blockUiOfOtherUsers = createAction('persistence/BLOCK_UI_OF_OTHER_USERS');
export const syncPersistedData = createAction('persistence/SYNC_DATA_BETWEEN_USERS');
